import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import JsonData from "../data/data.json";

const REGISTER_URL = `https://app.${JsonData?.Header?.nameBankDomain || "rbbnexus"}.com.br/register`;

const SLIDER_SETTINGS = {
  dots: true,
  infinite: true,
  speed: 700,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4600,
  arrows: true,
  adaptiveHeight: false,
  centerMode: false,
  variableWidth: false,
  pauseOnHover: true,
  pauseOnFocus: true,
  swipeToSlide: true,
};

const SLIDES = [
  {
     image: "/img/3slide.webp",
     title: "Estratégia, propósito",
     protectedText: "e conexão",
     subtitle: "para quem decide.",
   },
  {
     image: "/img/header.webp",
     title: "Visao estrategica para",
     protectedText: "decisões relevantes",
     subtitle: `A ${JsonData?.About?.nameBank || "RBB Capital Investimentos"} conecta inteligência e propósito para acelerar resultados.`,
   },
   {
     image: "/img/bank-metta.webp",
     title: "Confianca para",
     protectedText: "quem decide",
     subtitle: `${JsonData?.About?.nameBank || "RBB Capital Investimentos"}: estratégia, propósito e conexão em cada movimento.`,
   },
  
];

const openInNewTab = () => {
  window.open(REGISTER_URL, "_blank", "noreferrer");
};

const SlideItem = ({ slide }) => (
  <div className="slide-wrapper">
    <div className="slide-image">
      <img
        src={slide.image}
        alt={slide.title}
        loading="lazy"
        className="slide-img"
      />
      <div className="overlay">
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2 col-xs-12 intro-text">
              <div className="intro-panel">
                <img
                  src="/img/logo-rbb.png?v=20260501-1"
                  alt="Logo RBB Capital Investimentos"
                  className="hero-brand-logo"
                />
                <h1 className="upp">{slide.title}</h1>
                {slide.protectedText && (
                  <p className="protected-text">{slide.protectedText}</p>
                )}
                <p className="subtitle m-top m-bottom">{slide.subtitle}</p>
                <button className="btn btn-custom btn-lg" onClick={openInNewTab}>
                  Abra sua conta
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export const Slidershow = () => {
  // Se tiver só 1 slide → renderiza estático
  if (SLIDES.length === 1) {
    return (
      <div className="slideshow">
        <SlideItem slide={SLIDES[0]} />
      </div>
    );
  }

  // Se tiver mais de 1 slide → usa react-slick
  return (
    <div className="slideshow">
      <Slider {...SLIDER_SETTINGS}>
        {SLIDES.map((slide, index) => (
          <SlideItem key={index} slide={slide} />
        ))}
      </Slider>
    </div>
  );
};
